import { render } from "./NftProperties.vue?vue&type=template&id=30a788ae&scoped=true"
import script from "./NftProperties.vue?vue&type=script&lang=js"
export * from "./NftProperties.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftProperties.scss?vue&type=style&index=0&id=30a788ae&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a788ae"]])

export default __exports__